import { RSAA } from 'redux-api-middleware';
import { Base64 } from 'js-base64';
import validator from 'validator';
import A from '../actions/afspLoginActions';
import qs from 'qs';
import { ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

const 
{ htmlStorage } = ssSessionUtils;

export default {
    toggleAfspLoginModal: () => ({ type: A.TOGGLE_AFSP_LOGIN_MODAL }),
    toggleAfspLoginStatusModal: () => ({ type: A.TOGGLE_AFSP_LOGIN_STATUS_MODAL }),
    toggleAfspPasswordResetModal: () => ({ type: A.TOGGLE_AFSP_PASSWORD_RESET_MODAL }),
    toggleAfspLoginButtonDisable: () => ({ type: A.TOGGLE_AFSP_LOGIN_BUTTON_DISABLE }),
    changeAfspLoginModalView: view => ({ type: A.CHANGE_AFSP_LOGIN_MODAL_VIEW, payload: view }),
    resetAfspPasswordResetRequest: () => ({ type: A.RESET_AFSP_PASSWORD_RESET_REQUEST }),
    resetAfspLoginRequest: () => ({ type: A.RESET_AFSP_LOGIN_REQUEST }),
    doAfspLogin: ({ username, password }) => ({ [RSAA]: {
        method: 'post',
        endpoint: '/login',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;' },
        body: qs.stringify({username, password }),
        types: [
            A.AFSP_LOGIN_REQUEST_PENDING, 
            { 
                type: A.AFSP_LOGIN_REQUEST_SUCCESS,
                meta: (action, state, response) => {
                    let 
                    data = {},
                    token = response.headers.get('Authorization'),
                    tokenSet = token.split('.');

                    tokenSet.forEach((item, index) => {
                        if (index < (tokenSet.length - 1)) {
                            let obj = JSON.parse(Base64.decode(item));
                            for (let p in obj) data[p] = obj[p];
                        } else if (index === (tokenSet.length - 1)) data.hash = item;
                    });

                    htmlStorage().set({ ssSession: {...data, token }});
                    return response;
                }
            },
            A.AFSP_LOGIN_REQUEST_FAILURE
        ]
    }}),
    requestPasswordReset: ({ emailAddress, captcha, password, resetToken }) => ({ [RSAA]: {
        method: 'POST',
        endpoint: '/user/reset',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: emailAddress,
            type: validator.isEmail(emailAddress) ? 'EMAIL' : 'USERNAME',
            password: password || null,
            captcha: captcha || null
        }),
        types: [
            A.AFSP_PASSWORD_RESET_REQUEST_PENDING,
            A.AFSP_PASSWORD_RESET_REQUEST_SUCCESS,
            A.AFSP_PASSWORD_RESET_REQUEST_FAILURE
        ]
    }}),
    accountReactivation: ( userName ) => ({ [RSAA]: {
        method: 'POST',
        endpoint: '/user/generateReactivateEmail', 
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            userName: userName,
            token: null
        }),
        types: [
            A.REACTIVATE_USER_PENDING,
            A.REACTIVATE_USER_SUCCESS,
            A.REACTIVATE_USER_FAILURE
        ]
    }})
}